import React from 'react'

const Settings = () => {
  return (
    <div>
      <h1>Setting comming soon</h1>
    </div>
  )
}

export default Settings
